import { withStyles } from '@material-ui/core';

import ValetParking from './component';
import styles from './styles';

export default withStyles(styles)(ValetParking);
